import fetch from '../config/api'
/**
 * 展览列表(已结)
 * param {p} 平台，w、wx
 * param {language} 1 表示汉语 2表示英语 3表示藏语
 * param {type} 程 1 表示专题展览 2表示特展回眸
 * param {num} 分页时表示从第几条开始取
 * param {take} 分页时该值表示每页多少条数据
 */
const ExhibitionList = (language = '1', type = '1', num = '0', take = '10') => fetch('/exhibition/list', {
    p: 'wx',
    language,
    type,
    skip: num * take, //从第几个开始,
    take
});
/**
 * 展览列表(已结)
 * param {p} 平台，w、wx
 * param {language} 1 表示汉语 2表示英语 3表示藏语
 * param {exhibition_id} 展览ID
 */
const ExhibitionDetail = (language = '1', exhibition_id) => fetch('/exhibition/detail', {
    p: 'wx',
    language,
    exhibition_id,
});


export default {
    ExhibitionList,
    ExhibitionDetail
}